module.exports = __webpack_public_path__ + "themes/mf/fonts.css";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/fonts.css
// module id = 46
// module chunks = 3